import { Outlet } from "react-router-dom";

const FormConfigurationLayout = () => {
  return (
    <div className="h-full w-full overflow-hidden px-2 pb-2">
      <Outlet />
    </div>
  );
};

export default FormConfigurationLayout;
